import React, { Component } from 'react';
import styled from 'styled-components';
import getStackFrames from './utils/getStackFrames';
import StackTrace from './components/StackTrace';

const ErrorBlock = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ffffff;
  z-index: 1000100;
  display: block;
  flex-direction: column;
  height: 100%;
  width: 1024px;
  max-width: 100%;
  overflowx: hidden;
  overflowy: auto;
  padding: 0.5rem;
  box-sizing: border-box;
  text-align: left;
  font-size: 14px;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.5;
  color: #293238;
`;

const Header = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #ce1126;
  white-space: pre-wrap;
  margin: 0 2rem 0.75rem 0;
  flex: 0 0 auto;
  max-height: 50%;
  overflow: auto;
`;

const StackFrames = styled.div`
  font-size: 17px;
  line-height: 26px;
  background-color: rgba(251, 245, 180, 0.3);
`;

const Summary = styled.summary`
  font-size: 16px;
  color: #bbb;
`;

const Loading = styled.div`
  font-size: 16px;
  color: #bbb;
`;

class ErrorInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stackFrames: null,
      stackProcessed: false,
    };
    getStackFrames(props.error)
      .then((stackFrames) => {
        this.setState({
          stackFrames: stackFrames,
          stackProcessed: true,
        });
      })
      .catch((e) => {
        this.setState({
          stackFrames: null,
          stackProcessed: true,
        });
      });
  }

  render() {
    const { error, info } = this.props;
    const { stackFrames, stackProcessed } = this.state;
    let stackTrace = null;
    if (stackProcessed && stackFrames) {
      stackTrace = <StackTrace errorName={error.toString()} stackFrames={stackFrames} />;
    }
    if (!stackProcessed) {
      stackTrace = <Loading>Generating stack frames</Loading>;
    }

    return (
      <ErrorBlock>
        <Header>Error: {error && error.toString()}</Header>
        {stackTrace}
        <details>
          <Summary>Show Component Stack Trace</Summary>
          <StackFrames>{info.componentStack}</StackFrames>
        </details>
      </ErrorBlock>
    );
  }
}

export default ErrorInfo;
